<template>
  <section id="faq" class="py-24 bg-gray-50 dark:bg-dark-bg transition-colors duration-300">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-base font-semibold text-accent tracking-wide uppercase transition-colors duration-300">{{ t('faq.subtitle') }}</h2>
        <p class="mt-2 text-3xl font-extrabold text-gray-900 dark:text-white sm:text-4xl transition-colors duration-300">{{ t('faq.title') }}</p>
      </div>
      
      <div class="space-y-4">
        <div v-for="(item, index) in tm('faq.items')" :key="index"
          class="faq-item relative rounded-2xl border overflow-hidden shadow-sm transition-all duration-300"
          data-animate
          :style="{ animationDelay: index * 80 + 'ms' }"
          :class="[
            openIndex === index
              ? 'border-indigo-300 dark:border-indigo-700 bg-indigo-50/50 dark:bg-indigo-900/20'
              : [
                  'border-gray-200 dark:border-indigo-900/50',
                  index % 2 === 0 ? 'bg-white dark:bg-dark-surface' : 'bg-gray-50/50 dark:bg-dark-bg/30'
                ]
          ]"
        >
          <div class="absolute left-0 top-0 bottom-0 w-1 bg-indigo-500 rounded-l-2xl transition-opacity duration-300" :class="{ 'opacity-100': openIndex === index, 'opacity-0': openIndex !== index }"></div>
          <button @click="toggle(index)" class="w-full px-8 py-6 flex items-center justify-between text-left focus:outline-none transition-colors duration-300">
            <span class="text-lg font-semibold text-gray-900 dark:text-white transition-colors duration-300">{{ item.question }}</span>
            <ChevronDown class="w-5 h-5 text-gray-500 transition-all duration-300" :class="{ 'rotate-180 text-accent': openIndex === index }" />
          </button>
          <transition name="fade">
            <div v-show="openIndex === index" class="px-8 pb-6">
              <p class="text-gray-600 dark:text-gray-400 leading-relaxed transition-colors duration-300">{{ item.answer }}</p>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { ChevronDown } from 'lucide-vue-next'
import useAnimateOnScroll from '@/composables/useAnimateOnScroll'

const { t, tm } = useI18n({ useScope: 'global' })
const openIndex = ref(null)
const { observeElements } = useAnimateOnScroll(null, { animateClass: 'animate-in' })

onMounted(() => {
  observeElements('.faq-item')
})

const toggle = (index) => {
  openIndex.value = openIndex.value === index ? null : index
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
